/**
 * Avatar loading happens in Avatar so GitLab-hosted images can use the current
 * OAuth token. This component remains as a no-op compatibility shim.
 */
export const AvatarPreloader = () => null;

export default AvatarPreloader;
